import { Component, Input, ViewChild } from "@angular/core";
import { MatTab } from "@angular/material";

@Component({
    selector: "crew-wizard-tab",
    template: require('./crew-wizard-tab.component.html')
})
export class CrewWizardTab {
    @Input() label: string;

    @ViewChild('tab')
    public matTab: MatTab;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crew-wizard-tab.component.ts